import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiService } from '../../../api/apiClient';
import AuditFiltersBar from '../AuditFiltersBar';
import AuditTable, { statusPill, formatTs, monoShort } from '../AuditTable';
import InfoBox from '../InfoBox';
import useAuditList from '../useAuditList';

export default function ChatInteractionsTab({ onOpenTrace }) {
  const { t } = useTranslation();
  const { rows, loading, filters, setFilters, offset, limit, next, prev } =
    useAuditList(apiService.listAuditChat);

  const columns = [
    { key: 'timestamp', header: t('traceability:columns.timestamp'), render: (r) => formatTs(r.timestamp) },
    { key: 'status', header: t('traceability:columns.status'), render: (r) => statusPill(r.status) },
    { key: 'question', header: t('traceability:columns.question'),
      render: (r) => <pre className="whitespace-pre-wrap text-xs text-ink-secondary max-w-sm">{(r.question || '').slice(0, 200)}</pre> },
    { key: 'answer', header: t('traceability:columns.answer'),
      render: (r) => <pre className="whitespace-pre-wrap text-xs text-ink-secondary max-w-sm">{(r.answer || '').slice(0, 200)}</pre> },
    { key: 'confidence', header: t('traceability:columns.confidence'),
      render: (r) => r.confidence != null ? `${(r.confidence * 100).toFixed(0)}%` : '—' },
    { key: 'tokens', header: t('traceability:columns.tokens'),
      render: (r) => {
        const ti = r.total_tokens_in, to = r.total_tokens_out, th = r.total_thoughts_tokens;
        if (ti == null && to == null) return '—';
        const base = `${ti ?? 0}→${to ?? 0}`;
        return th ? <span title={`thoughts: ${th}`}>{base} <span className="text-ink-muted">(+{th}t)</span></span> : base;
      } },
    { key: 'latency_ms', header: t('traceability:columns.latency') },
    { key: 'trace_id', header: t('traceability:columns.traceId'),
      render: (r) => <button onClick={(e) => { e.stopPropagation(); onOpenTrace(r.trace_id); }}
                             className="hover:text-accent-text">{monoShort(r.trace_id, 10)}</button> },
  ];

  return (
    <div>
      <InfoBox tabKey="chat" />
      <AuditFiltersBar value={filters} onChange={setFilters} />
      <AuditTable rows={rows} columns={columns} loading={loading}
                  limit={limit} offset={offset} onNext={next} onPrev={prev}
                  onRowClick={(r) => onOpenTrace(r.trace_id)} />
    </div>
  );
}
